import React from 'react';
import moment from 'moment';
import { injectIntl } from 'react-intl';

const getDateString = (date, t) => {
  const today = moment();
  const tomorrow = moment().add(1, 'day');
  const day = moment(date);

  if (today.isSame(day, 'day')) {
    return t.today;
  }

  if (tomorrow.isSame(day, 'day')) {
    return t.tomorrow;
  }

  return day.format(t.other_day);
};

const AssignmentDate = ({ date, intl }) => {
  const t = intl.messages.modules.dispatching.assignment.header_date;
  return <div className="header-date">{getDateString(date, t)}</div>;
};
export default injectIntl(AssignmentDate);
